import { DentalInsuranceReportTypes } from '@frontend/api-insurance-eligibility-report';
import { i18next } from '@frontend/i18n';
import { TableColumnConfig } from '@frontend/design-system';
import {
  getAmountColumnConfig,
  getBenefitLimitationColumnConfig,
  getCategoryConfig,
  getCodeColumnConfig,
  getCoverageColumnConfig,
  getCoverageLevelColumnConfig,
  getDescriptionColumnConfig,
  getNetworkNameConfig,
  getNotesColumnConfig,
  getPeriodUnitConfig,
  getRemainingConfig,
  InsuranceReportTableColumnKeysType,
} from '../../components/InsuranceTables/insurance-reports-table-columns.helper';
import { TableDataType, TablesDataType, TuuthFairyTableType } from '../../types/types';

export const getAllInsuranceReportTableColumnKeysForTuuthFairy = (): InsuranceReportTableColumnKeysType[] => {
  return [
    {
      id: 'notes',
      label: i18next.t('Notes', { ns: 'insuranceEligibilityReport' }),
    },
    {
      id: 'waitingPeriod',
      label: i18next.t('Waiting Period', { ns: 'insuranceEligibilityReport' }),
    },
    {
      id: 'deductibleApplies',
      label: i18next.t('Deductible Applies', { ns: 'insuranceEligibilityReport' }),
    },
    {
      id: 'coPay',
      label: i18next.t('Co Pay', { ns: 'insuranceEligibilityReport' }),
    },
    {
      id: 'ageMax',
      label: i18next.t('Age Max', { ns: 'insuranceEligibilityReport' }),
    },
    {
      id: 'ageMin',
      label: i18next.t('Age Min', { ns: 'insuranceEligibilityReport' }),
    },
    {
      id: 'coverage',
      label: i18next.t('Coverage', { ns: 'insuranceEligibilityReport' }),
    },
    {
      id: 'code',
      label: i18next.t('Code', { ns: 'insuranceEligibilityReport' }),
    },
    {
      id: 'description',
      label: i18next.t('Description', { ns: 'insuranceEligibilityReport' }),
    },
    {
      id: 'limitation',
      label: i18next.t('Limitation', { ns: 'insuranceEligibilityReport' }),
    },
    {
      id: 'category',
      label: i18next.t('Category', { ns: 'insuranceEligibilityReport' }),
    },
    {
      id: 'networkName',
      label: i18next.t('Network Name', { ns: 'insuranceEligibilityReport' }),
    },
    {
      id: 'networkType',
      label: i18next.t('Network Type', { ns: 'insuranceEligibilityReport' }),
    },
    {
      id: 'remaining',
      label: i18next.t('Remaining', { ns: 'insuranceEligibilityReport' }),
    },
    {
      id: 'amount',
      label: i18next.t('Amount', { ns: 'insuranceEligibilityReport' }),
    },
    {
      id: 'coverageLevel',
      label: i18next.t('Coverage Level', { ns: 'insuranceEligibilityReport' }),
    },
    {
      id: 'periodUnit',
      label: i18next.t('Period Unit', { ns: 'insuranceEligibilityReport' }),
    },
  ];
};

export const getMaximumTableColumnsForTuuthFairy = (): TableColumnConfig<TableDataType>[] => {
  return [
    getCategoryConfig('70'),
    getRemainingConfig('50'),
    getAmountColumnConfig('50'),
    getPeriodUnitConfig(),
    getCoverageLevelColumnConfig('70'),
    getNetworkNameConfig('70'),
  ];
};

export const getDeductibleTableColumnsForTuuthFairy = (): TableColumnConfig<TableDataType>[] => {
  return [
    getCategoryConfig('70'),
    getRemainingConfig('50'),
    getAmountColumnConfig('50'),
    getPeriodUnitConfig(),
    getCoverageLevelColumnConfig('70'),
    getNetworkNameConfig('70'),
  ];
};

export const getBenefitsTableColumnsForTuuthFairy = () => {
  return [
    getCategoryConfig(),
    getCodeColumnConfig(),
    getCoverageColumnConfig(),
    getBenefitLimitationColumnConfig(),
    getDescriptionColumnConfig(),
    getNotesColumnConfig(),
  ];
};

export const prepareLimitationColumn = (benefit: TuuthFairyTableType) => {
  if (benefit.limit && benefit.period && benefit.periodUnit) {
    return (
      benefit.limit + '/' + (benefit.period === 1 ? benefit.periodUnit : benefit.period + benefit.periodUnit + 's')
    );
  } else {
    return null;
  }
};
//Below are the tables which will be shown for tuuthfairy data
export const getInsuranceReportTableColumnsForTuuthFairy = (
  tableName: keyof TablesDataType,
  keys: (keyof DentalInsuranceReportTypes.DentalXChangeDentalSummaryInfo)[]
) => {
  switch (tableName) {
    case 'deductible':
      return keys.includes('deductible') ? getDeductibleTableColumnsForTuuthFairy() : [];
    case 'maximum':
      return keys.includes('maximum') ? getMaximumTableColumnsForTuuthFairy() : [];
    case 'limitation':
      return keys.includes('limitation') ? getBenefitsTableColumnsForTuuthFairy() : [];
    default:
      throw new Error('Unrecognised table');
  }
};
